import { useEffect, useState } from "react";

/**
 * Delays update until after `delay` milliseconds have elapsed
 * since the last time `state` was changed.
 *
 * Relies on `useEffect` to detect `state` change.
 *
 * Resets the timer on `delay` change.
 */
export const useDebouncedState = <T>(state: T, delay: number): T => {
  const [debouncedState, setDebouncedState] = useState(state);
  useEffect(() => {
    const t = setTimeout(() => {
      setDebouncedState(state);
    }, delay);
    return () => {
      clearTimeout(t);
    };
  }, [state, delay]);
  return debouncedState;
};
